var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53563 8.89722C4.18896 5.78522 7.39296 3.49989 10.2236 4.84122L26.149 12.3852C29.1996 13.8292 29.1996 18.1706 26.149 19.6146L10.2236 27.1599C7.39296 28.5012 4.19029 26.2159 4.53563 23.1039L5.17563 17.3332H15.9996C16.3532 17.3332 16.6924 17.1927 16.9424 16.9427C17.1925 16.6926 17.333 16.3535 17.333 15.9999C17.333 15.6463 17.1925 15.3071 16.9424 15.0571C16.6924 14.807 16.3532 14.6666 15.9996 14.6666H5.17696L4.53563 8.89722Z",
    fill: "#0E8080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.e1639a791763ddc2368666133c78bec5.svg";
export { ForwardRef as ReactComponent };